// LiBRARY
import React from 'react';
import QuestionCategorytable from './table';

class Questionnaire extends React.Component {
	render() {
		return (
			<div style={{ marginTop: -50 }}>
				<QuestionCategorytable />
			</div>
		);
	}
}

export default Questionnaire;
